<template>
    <button
        @click="toggleFilter"
        @keydown.esc="filterOpen = false"
        :aria-controls="ariaControlsId"
        :aria-label="ariaLabelName"
        :aria-expanded="filterOpen ? 'true' : 'false'"
        :class="additionalClasses"
        class="filter-toggle btn btn-primary">
        <span class="open-text">
          {{ openText }}
          <svg class="icon"><use xlink:href="#icon-filter"></use></svg>
        </span>
        <span class="closed-text">
          {{ closeText }}
          <svg class="icon"><use xlink:href="#icon-close"></use></svg>
        </span>
    </button>
</template>

<script>
import MenuState from "../mixins/MenuState";

export default {
    name: "MenuToggle",

    props: {
        ariaControlsId: {
            type: String,
            required: true
        },
        ariaLabelName: {
            type: String,
            required: true
        },
        openText: {
            type: String,
            default: 'Open filter'
        },
        closeText: {
            type: String,
            default: 'Sluit filter'
        },
        additionalClasses: {
            type: String,
            default: ''
        }
    },

    mixins: [MenuState]

}
</script>
